<template>
    <div>
        <menu-bar v-if="menu"/>
        <div class="container" role="main" v-if="caixa">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a :href="'#/'"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a :href="'#/caixas-pacpon'"><i class="fa fa-suitcase" aria-hidden="true"></i> CAIXAS PAC-PON</a></li>
                    <li class="active">CADASTRO DE CAIXAS PAC-PON</li>
                </ol>

                <div class="row">
                    <div class="col-sm-6">
                        <go-back v-if="menu" :url="'#/caixas-pacpon'"/> &nbsp;
                        <button type="button" v-if="user.level < 5" :disabled="! caixa.cto._id"
                                @click="save()"
                                class="btn btn-success">
                            <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR CAIXAS PAC-PON
                        </button>
                    </div>
                    <div class="col-sm-6 text-right">
                        <button type="button" v-if="caixa._id"
                                @click="createOrdem()"
                                class="btn btn-info">
                            <i class="fa fa-cog" aria-hidden="true"></i> CRIAR ORDEM CAIXAS PAC-PON
                        </button>
                    </div>
                </div>

                <br v-if="menu"/><br v-if="menu"/>

                <form class="form-horizontal" v-if="caixa">

                    <div class="panel panel-info">
                        <!-- Default panel contents -->
                        <div class="panel-heading">
                            <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                        </div>

                        <div class="panel-body">
                            <div class="form-group">

                                <div class="col-sm-3">
                                    <label for="nome" class="control-label">NOME DO PAC-PON</label>
                                    <input id="nome" disabled type="text" :value="caixa.nome" class="form-control" >
                                </div>

                                <div class="col-sm-3">
                                    <label for="pon" class="control-label">PORTA PON</label>
                                    <input id="pon" disabled type="text" :value="(caixa.porta_pon && caixa.porta_pon.nome) ? caixa.porta_pon.nome : null" class="form-control" >
                                </div>

                                <div class="col-sm-3">
                                    <label for="fibra" class="control-label">FIBRA</label>
                                    <input id="fibra" disabled type="text" :value="(caixa.fibra.numero) ? 'FO-' + caixa.fibra.numero : null" class="form-control" >
                                </div>

                                <div class="col-sm-3">
                                    <label for="portas" :class="{'text-danger': !caixa.cto._id}" class="control-label">CAIXA CTO</label>
                                    <select id="portas" v-model="caixa.cto._id" class="form-control" @change="portaSelecionada">
                                        <option :value="null">NENHUM CTO</option>
                                        <option v-for="p of caixas" v-bind:key="p._id" :value="p._id">{{ p.nome }}</option>
                                    </select>
                                </div>

                                <div class="col-sm-3">
                                    <label for="limite_banda" class="control-label">LIMITE DE BANDA (MB)</label>
                                    <input id="limite_banda" type="text" v-model.number="caixa.limite_banda" class="form-control" >
                                </div>

                                <div class="col-sm-3">
                                    <label for="banda_usada" class="control-label">BANDA USADA (MB)</label>
                                    <input id="banda_usada" disabled type="text" v-model.number="caixa.banda_usada" class="form-control" >
                                </div>

                                <div class="col-sm-3">
                                    <label for="vlan" class="control-label">VLAN</label>
                                    <input id="vlan" type="text" v-model="caixa.vlan" class="form-control" >
                                </div>

                                <div class="col-sm-3">
                                    <label for="onu_mac" class="control-label">ONU MAC</label>
                                    <input id="onu_mac" autocomplete="off" type="text" v-model="caixa.onu_mac" class="form-control" >
                                </div>

                                <div class="col-sm-3">
                                    <label for="contem_switch" class="control-label">CONTÉM SWITCH?</label>
                                    <select id="contem_switch" v-model="caixa.switch" class="form-control">
                                        <option :value="true">SIM</option>
                                        <option :value="false">NÃO</option>
                                    </select>
                                </div>

                                <div class="col-sm-3">
                                    <label for="contem_switch" class="control-label">MODELO SWITCH</label>
                                    <combo-modelo-switch :disabled="!caixa.switch" v-model="caixa.modelo_switch._id" />
                                </div>

                                <div class="col-sm-12" v-if="!caixa.switch">
                                    <div v-if="caixa.switch === false && caixa.modelo_switch" style="margin-top: 10px" class="alert alert-dismissible alert-warning">
                                        <h4>Alerta!</h4>
                                        <p class="text-uppercase">Ao salvar será retirado este modelo da PACPON</p>
                                    </div>

                                    <div v-if="caixa.switch === null || caixa.switch === undefined" style="margin-top: 10px" class="alert alert-dismissible alert-warning">
                                        <h4>Alerta!</h4>
                                        <p class="text-uppercase">Informe se existe algum switch na caixa</p>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <label for="obs" class="control-label">OBS DA PAC-PON</label>
                                    <textarea id="obs" rows="5" v-model="caixa.obs" class="form-control" ></textarea>
                                </div>

                            </div>
                        </div>
                    </div>

                    <place :place.sync="caixa.place" :height="'500px'" />

                    <div class="form-group">
                        <div class="col-sm-10">
                            <button type="button" v-if="user.level < 5" :disabled="! caixa.cto._id"
                                    @click="save()"
                                    class="btn btn-success">
                                <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR CAIXAS PAC-PON
                            </button> &nbsp;

                            <button type="button" v-if="user.level < 5 && caixa.onu_mac"
                                    @click="remover()"
                                    class="btn btn-danger">
                                <i class="fa fa-floppy-o" aria-hidden="true"></i> REMOVER ONU
                            </button>
                        </div>
                    </div>

                </form>

                <br/>

                <status-da-onu :_id="caixa._id" v-if="caixa && caixa._id && caixa.onu_mac"/>

                <br/>
                <list-switchs-by-pag-pon :_id="caixa._id" v-if="caixa && caixa._id" />
                <br/>
                <list-clientes-no-pacpon :portas="(caixa.modelo_switch && caixa.modelo_switch.qtde_portas) ? caixa.modelo_switch.qtde_portas : 1" :_id="caixa._id" v-if="caixa && caixa._id "/>

            </div>

        </div>
    </div>
</template>
<script>
import { CaixaCTO, CaixaPacPon, Fiberhome } from "../../../class/index";
import { Place, StatusDaOnu } from "../../../components/exports";
import ListSwitchsByPagPon from "../../../components/lists/ListSwitchsByPagPon";
import ListClientesNoPacpon from "../../../components/lists/ListClientesNoPacpon";
import GoBack from "../../../components/buttons/goback";
import ModeloSwitch from "../../../menus/modelo-switch";
import ComboModeloSwitch from "../../../components/combo/modelo-switch";

/* global swal */

export default {
    components: {
        ModeloSwitch,
        ComboModeloSwitch,
        Place,
        GoBack,
        ListSwitchsByPagPon,
        ListClientesNoPacpon,
        StatusDaOnu
    },
    data() {
        return {
            menu: true,
            user: null,
            caixa: null,
            caixas: [],
            fibras: []
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadCTOs();
        if (this.$route.query.disable_menu === "1") {
            this.menu = false;
        }
        if (this._id) {
            this.loadPonto(this.$route.params.id);
        } else if (this.$route.params.lat && this.$route.params.lng) {
            this.caixa = CaixaPacPon.create();
            this.caixa.place = [
                Number(this.$route.params.lng),
                Number(this.$route.params.lat)
            ];
            this.menu = false;
        } else {
            this.caixa = CaixaPacPon.create();
        }
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        async loadPonto() {
            let caixa = await CaixaPacPon.byID(this._id);
            if (!caixa.obs) {
                caixa.obs = null;
            }
            if (!caixa.modelo_switch) {
                caixa.modelo_switch = {
                    _id: null
                };
            }
            this.caixa = caixa;
        },
        async loadCTOs() {
            this.caixas = await CaixaCTO.all();
        },
        portaSelecionada() {
            let caixas = this.caixas.filter(caixa => {
                return caixa._id === this.caixa.cto._id;
            });

            if (caixas.length) {
                this.caixa.porta_pon = caixas[0].porta_pon;
                this.caixa.fibra = caixas[0].fibra;
            }
        },
        remover() {
            swal.queue([
                {
                    title: "REMOVER",
                    confirmButtonText: "Remover",
                    text: "Posso remover este ONU?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () =>
                        new Promise(resolve => {
                            Fiberhome.unregister(this.caixa._id)
                                .then(() => {
                                    resolve();
                                    this.loadPonto();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        })
                }
            ]);
        },
        save() {
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o ponto?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () =>
                        new Promise(resolve => {
                            CaixaPacPon.save(this.caixa)
                                .then(() => {
                                    resolve();
                                    if (this.menu) {
                                        this.$router.push({
                                            path: "/caixas-pacpon"
                                        });
                                    } else {
                                        window.close();
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        })
                }
            ]);
        },

        createOrdem() {
            swal.queue([
                {
                    title: "ORDEM DE SERVIÇO",
                    confirmButtonText: "Salvar",
                    text: "Posso criar a Ordem para esta caixa?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () =>
                        new Promise(resolve => {
                            CaixaPacPon.criarOrdem(this.caixa._id)
                                .then(() => {
                                    resolve();
                                    swal("Solicitado a criação da Ordem!");
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        })
                }
            ]);
        }
    }
};
</script>
